import PrimaryButton from "Components/atoms/buttons/primary-button"
import SecondaryButton from "Components/atoms/buttons/secondary-button"
import { CSSProperties } from "react"

interface AreYouSureButtonsProps {
    handleAccept: () => any
    handleDecline: () => any
    acceptText: string
    declineText: string
    declineButtonStyle?: CSSProperties
    acceptButtonStyle?: CSSProperties
    disable?: boolean
    /** Locks accept on its own, leaving decline usable. */
    disableAccept?: boolean
    className?: string
}


const AreYouSureButtons = ({
    handleAccept,
    handleDecline,
    acceptText,
    declineText,
    acceptButtonStyle,
    declineButtonStyle,
    disable,
    disableAccept,
    className
}: AreYouSureButtonsProps) => {
    return <div className={className ? className : "d-flex gap-2"}>
        <SecondaryButton className="w-100" disabled={disable} style={declineButtonStyle} onClick={handleDecline}>{declineText}</SecondaryButton>
        <PrimaryButton className="w-100" disabled={disable || disableAccept} style={acceptButtonStyle} onClick={handleAccept}>{acceptText}</PrimaryButton>
    </div>

}


export default AreYouSureButtons